import { render, staticRenderFns } from "./timeAxis.vue?vue&type=template&id=298fbbbf&scoped=true"
import script from "./timeAxis.vue?vue&type=script&lang=js"
export * from "./timeAxis.vue?vue&type=script&lang=js"
import style0 from "./timeAxis.vue?vue&type=style&index=0&id=298fbbbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fbbbf",
  null
  
)

export default component.exports